import SkeletonLoader from '.';

const AdminDetailsSkeleton = () => {
  return (
    <div className="space-y-10 w-full animate-pulse">
      {/* Profile Skeleton */}
      <div className="flex flex-col items-center gap-4">
        <SkeletonLoader variant="circle" className="w-25 h-25" />
        <SkeletonLoader variant="rect" className="w-48 h-8 rounded-lg" />
        <SkeletonLoader variant="rect" className="w-24 h-6 rounded-full" />
      </div>

      {/* Status & Export Skeleton */}
      <div className="flex justify-between items-center">
        <SkeletonLoader variant="rect" className="w-40 h-6 rounded-lg" />
        <SkeletonLoader variant="rect" className="w-32 h-12 rounded-lg" />
      </div>

      {/* Email & Creation Date Skeleton */}
      <div className="flex gap-6">
        <div className="flex-1 space-y-2">
          <SkeletonLoader variant="rect" className="w-24 h-4 rounded-lg" />
          <SkeletonLoader variant="rect" className="w-full h-6 rounded-lg" />
        </div>
        <div className="flex-1 space-y-2">
          <SkeletonLoader variant="rect" className="w-24 h-4 rounded-lg" />
          <SkeletonLoader variant="rect" className="w-full h-6 rounded-lg" />
        </div>
      </div>

      {/* Permissions Skeleton */}
      <div className="flex flex-col gap-4">
        <SkeletonLoader variant="rect" className="w-48 h-7 rounded-lg" />
        <div className="border border-neutral-light-200 rounded-2xl p-6 space-y-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex justify-between items-center">
              <SkeletonLoader variant="rect" className="w-32 h-5 rounded-lg" />
              <SkeletonLoader
                variant="rect"
                className="w-10 h-5 rounded-full"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDetailsSkeleton;
